import privateInstance from "../privateClient";
import { FetchLoadTypesQueryType } from "./types";

export const loadTypesApi = {
  getLoadTypes: async () => {
    try {
      const response = await privateInstance.get<
        FetchLoadTypesQueryType["Data"]
      >("/rate-manager/load-type-configurations");

      return response.data;
    } catch (err) {
      return null;
    }
  },
};
